<template>
    <lq-el-form
        ref="loginForm"
        :rules="rules"
        name="register"
        autocomplete="off"
        @submited-success="submitedSuccess"
        action="register-event-manager"
        :static-data="{email: $route.params.email, role: 'event-manager'}"
    >
        <el-card shadow="always">
            <h3 style="text-align:center">Register As Manager</h3>

            <lq-el-input id="name" placeholder="Name" autocomplete="off" />
            <lq-el-input
                id="password"
                type="password"
                :rules="rules.password"
                placeholder="Password"
                autocomplete="off"
            />
            <el-row align="centre" justify="end">
                <el-col :span="12">
                    <lq-el-submit label="Register" />
                </el-col>
            </el-row>
        </el-card>
    </lq-el-form>
</template>
<script>
export default {
    name: 'login-form',
    data: function() {
        return {
            rules: {
                password: {
                    presence: {
                        allowEmpty: false,
                        message: 'Password field is required'
                    }
                },
                name: {
                    presence: {
                        allowEmpty: false,
                        message: 'Name field is required'
                    }
                }
            }
        };
    },
    methods: {
        /**
         * When login Success then store token and refresh token in cookie.
         */
        submitedSuccess: function(response) {
            this.$message.success(response.message);
        }
    }
};
</script>
<style lang="sass">
    
</style>

